export default '/build/22ff7c4b.jpg'